// **********************************************************
// Help Slider
// **********************************************************

const helpSlider = document.querySelectorAll('[data-slider="help-swiper"]');

const helpSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};

const initHelpSlider = (el) => {
  const parentEle = el.closest('.help-slider');

  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');
  const pagination = parentEle.querySelector('.swiper-pagination');

  const options = {
    ...helpSliderOptions,
    pagination: {
      ...helpSliderOptions.pagination,
      el: pagination,
    },
    navigation: {
      prevEl: arrowLeft,
      nextEl: arrowRight,
    },
  };

  new Swiper(el, options);
};

helpSlider.forEach((el) => initHelpSlider(el));

setupResponsiveSliders({
  sliderElements: helpSlider,
  breakpoint: breakpointSm,
  initSlider: initHelpSlider,
  mobileFallback: [enableProgressSync, enableArrowScrollSync],
  parentSelector: '[data-slider-parent]',
});
